import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="md">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    textAlign: 'center',
                    padding: 4,
                }}
            >
                <ErrorOutlineIcon
                    sx={{
                        fontSize: 120,
                        color: '#003B93',
                        marginBottom: 2,
                        opacity: 0.8,
                    }}
                />
                <Typography
                    variant="h1"
                    sx={{
                        fontSize: { xs: '4rem', sm: '6rem', md: '8rem' },
                        fontWeight: 'bold',
                        color: '#003B93',
                        marginBottom: 1,
                        lineHeight: 1,
                    }}
                >
                    404
                </Typography>
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 600,
                        color: '#333',
                        marginBottom: 2,
                        fontSize: { xs: '1.5rem', sm: '2rem' },
                    }}
                >
                    Page Not Found
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        color: '#666',
                        marginBottom: 4,
                        maxWidth: '500px',
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                    }}
                >
                    The page you are looking for does not exist or has been moved!
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<HomeIcon />}
                    onClick={() => navigate('/admin/UltimateHoldingCompany')}
                    sx={{
                        backgroundColor: '#003B93',
                        color: 'white',
                        padding: '12px 32px',
                        fontSize: '1rem',
                        fontWeight: 600,
                        textTransform: 'none',
                        borderRadius: '8px',
                        '&:hover': {
                            backgroundColor: '#002a6b',
                        },
                    }}
                >
                    Go to Home
                </Button>
            </Box>
        </Container>
    );
};

export default NotFound;
